import confirmationmodaltpl from './confirmationModal.tpl.html';

export class ConfirmationModal {
  closeModal() {
    this.onModalClose({});
  }

  acceptModal() {
    this.onModalAccept({});
  }
}

export const confirmationModal = {
  template: confirmationmodaltpl,
  controller: ConfirmationModal,
  bindings: {
    onModalClose: '&',
    onModalAccept: '&',
  },
};
